import styled from 'styled-components';

const StyledContainer = styled.div`
	position: absolute;
	top: 155px;
	left: 50%;
	transform: translateX(-50%);
	width: 1024px;
	height: auto;
	background: #111314;
	padding: 30px 0px 0 30px;
	border: 1px solid rgba(255, 255, 255, 0.1);
	box-shadow: 0px 6px 80px rgba(0, 0, 0, 0.5);
	border-radius: 10px;
`;

const StyledLayout = styled.div`
	display: grid;
	grid-template-columns: 410px 1px 1fr;
`;

export { StyledContainer, StyledLayout };
